import Api from './rest/SpecificationApi';

export default new Api();
